const CalculationsAverage = (data) => {

  return data.reduce((a, b) => Number(a) + Number(b), 0) / data.length;
}

export default CalculationsAverage;
